import Vue from 'vue';

const serviceBasePath = '/api/auth';

const state = {
  status: '',
  token: localStorage.getItem('token') || '',
  user: {},
};

const getters = {
  isLoggedIn(state: any) {
    return !!state.token;
  },
  authStatus(state: any) {
    return state.status;
  },
};

const actions = {
  async login({ commit, state }: any, { username, password }: any) {
    try {
      const result: any = await Vue.axios.post(serviceBasePath+'/login', {
        group: 'admin',
        username,
        password
      });

      const { data } = result;
      if (data && data.token) {
        localStorage.setItem('token', data.token);
        Vue.axios.defaults.headers.common['Authorization'] = data.token;
        commit('auth_success', data.token);
      }
      
      return data;
    } catch (err) {
      commit('auth_error');
      localStorage.removeItem('token');
      console.error(err);
      throw 'Login failed. Please try again later.';
    }
  },
  logout({ commit }: any) {
    commit('logout');
    localStorage.removeItem('token');
  },
};

const mutations = {
  auth_request(state: any) {
    state.status = 'loading';
  },
  auth_success(state: any, token: any) {
    state.status = 'success';
    state.token = token;
  },
  auth_error(state: any) {
    state.status = 'error';
  },
  logout(state: any) {
    state.status = '';
    state.token = '';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}